import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  section: {
    marginTop: theme.marginBase * 7,
  },
  title: {
    ...theme.fonts.h4,
    marginBottom: theme.marginBase * 3,
  },
}));

interface Props {
  title: string;
  children: React.ReactNode;
}

export const TargetingSection = ({ title, children }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <section className={classes.section}>
      <h2 className={classes.title}>{title}</h2>
      {children}
    </section>
  );
};
